import React from "react";
import {graphql, StaticQuery} from "gatsby";

export default (props) => (
	<StaticQuery
		query={graphql`
      query {
				 site {
						 siteMetadata {
								 product {
										 version
								 }
						 }
				 }
      }
    `}
		render={(data) => <a href={"https://www.pseekoo.at/bike-fit/bike-fit-" + props.stage + "-v" + data.site.siteMetadata.product.version + ".html" }>{props.title}</a>}
	/>
);